<template>
  <div v-if="hasVideo" class="video-block">
    <div class="video-container">
      <iframe
        :src="embedUrl"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </div>
    <p v-if="caption" class="video-caption">{{ caption }}</p>
  </div>
</template>

<script>
export default {
  name: 'VideoBlock',
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    caption() {
      return this.data.caption || ''
    },
    resolvedUrl() {
      let url = this.data.url
      // Migration: reconstruct from old provider+videoId format
      if (!url && this.data.provider === 'youtube' && this.data.videoId) {
        url = `https://www.youtube.com/embed/${this.data.videoId}`
      }
      if (!url && this.data.provider === 'vimeo' && this.data.videoId) {
        url = `https://player.vimeo.com/video/${this.data.videoId}`
      }
      if (!url) return ''
      // Use privacy-enhanced domain to avoid cross-site cookie rejections
      return url.replace('www.youtube.com/embed/', 'www.youtube-nocookie.com/embed/')
    },
    hasVideo() {
      return !!this.resolvedUrl
    },
    embedUrl() {
      return this.resolvedUrl
    }
  },
  mounted() {
    if (!this.hasVideo) {
      console.error('[VideoBlock] Missing or unrecognised video URL — block will not render.')
    }
  }
}
</script>

<style scoped>

.video-block {
  width: 100%;
  padding: 0;
}


.video-container {
  aspect-ratio: 16 / 9;
  width: 100%;
  border-radius: 6px;
  overflow: hidden;
  background: var(--color-text);

  iframe {
    width: 100%;
    height: 100%;
    display: block;
  }
}

.video-caption {
  margin: 10px 0 0 0;
  font-family: var(--font-primary);
  font-size: var(--font-sm);
  line-height: var(--line-height-base);
  color: color-mix(in srgb, var(--color-text) 75%, var(--color-bg));
  text-align: center;
}
</style>
